import { Panel } from '@src/components/Panel/Panel';
import { ChevronDownIcon } from '@src/components/icons/ChevronDownIcon';
import type { ReactNode } from 'react';
import { PremiumFeatureBadge } from '@src/components/PremiumBadge/PremiumFeatureBadge';
import { OrganizerPanelHeading } from './OrganizerPanelHeading';
import './OrganizerSection.css';

export function OrganizerPanelHeader({ children }: { children: ReactNode }) {
  return <div className="organizer-panel-section__header">{children}</div>;
}

/** Tab content stays visible unless a panel explicitly opts into a disclosure. */
export function OrganizerPanelSection({ embedded = false, title, premium = false,
  premiumFeature, icon, id, children, hideHeading = false, headerActions, collapsible = false,
}: {
  mobile: boolean;
  collapsible?: boolean;
  hideHeading?: boolean;
  headerActions?: ReactNode;
  embedded?: boolean;
  gameKey: string;
  title: ReactNode;
  premium?: boolean;
  premiumFeature?: string;
  icon: ReactNode;
  id: string;
  children: ReactNode;
  defaultOpen?: boolean;
}) {
  if (embedded) return <div data-testid={`organizer-section-${id}`}>{children}</div>;
  if (collapsible) return <Panel as="details" padding="none" elevated id={id} className="organizer-section organizer-panel-section" testId={`organizer-section-${id}`}>
    <summary>
      <span className="organizer-section__icon">{icon}</span>
      <span className="organizer-section__title">{title}</span>
      {headerActions ?? (premium && premiumFeature ? <PremiumFeatureBadge feature={premiumFeature} /> : null)}
      <ChevronDownIcon className="organizer-section__chevron" />
    </summary>
    <div className="organizer-section__body">{children}</div>
  </Panel>;
  return <Panel as="section" padding="none" elevated id={id} className="organizer-section organizer-panel-section" testId={`organizer-section-${id}`}>
    {!hideHeading && <OrganizerPanelHeader>
      <OrganizerPanelHeading icon={icon}
        actions={headerActions ?? (premium && premiumFeature ? <PremiumFeatureBadge feature={premiumFeature} /> : undefined)}>
        {title}
      </OrganizerPanelHeading>
    </OrganizerPanelHeader>}
    <div className={`organizer-section__body${hideHeading ? ' organizer-panel-section__body--no-heading' : ''}`}>{children}</div>
  </Panel>;
}
